import React from 'react'
import { useSelector } from 'react-redux'
import styles from 'srcReact/SearchPage/components/styles.module.scss'
import Mixrs from 'srcReact/SearchPage/components/Mixrs'
import Groups from 'srcReact/SearchPage/components/Groups'
import Members from 'srcReact/SearchPage/components/Members'
import Media from 'srcReact/SearchPage/components/Media'
import Posts from 'srcReact/SearchPage/components/Posts'

const OrderedComponents = ({ id, type, commonProps }) => {
  let Component

  switch (type) {
    case 'mixr':
      Component = Mixrs
      break
    case 'group':
      Component = Groups
      break
    case 'member':
      Component = Members
      break
    case 'media':
      Component = Media
      break
    case 'post':
      Component = Posts
      break
  }

  return <Component scope='all' id={id} {...commonProps} />
}

const All = ({ ...commonProps }) => {
  const {
    globalSearch: { results }
  } = useSelector((state) => state)

  return (
    <div className={styles.searchContentWrapper}>
      {results?.length > 0 &&
        results.map((result, index) => (
          <OrderedComponents key={index} id={result.id} type={result.type} commonProps={commonProps} />
        ))}
    </div>
  )
}

export default All
